import { instance } from "../axios/axiosConfig";
import {
  CreatorByIdData,
  CreatorData,
  CreatorInteractionsData,
  DownloadCreatorsParams,
  ManageCreatorData,
} from "../types/creatorsTypes.tsx";
import { CreatorContactInfo } from "../types/creatorsTypes.tsx";

interface FetchCreatorsParams {
  persona_id?: number;
  interest_id?: string;
}

const creatorsApi = {
  fetchCreatorsList(params?: FetchCreatorsParams) {
    return instance.get<CreatorData[]>(`/api/creators/`, { params });
  },
  fetchManageCreatorsList() {
    return instance.get<ManageCreatorData[]>(`/api/creators/manage-list/`);
  },
  fetchCreatorById(id: string | number) {
    return instance.get<CreatorByIdData>(`/api/creators/${id}/`);
  },
  fetchCreatorContactsById(id: number) {
    return instance.get<CreatorContactInfo>(`/api/creators/${id}/contact/`);
  },
  interactionsCreator(data: CreatorInteractionsData) {
    return instance.post(`/api/creators/${data.id}/interactions/`, data.body);
  },
  deleteStatusCreator(id: number) {
    return instance.delete(`/api/creators/${id}/interactions/`);
  },
  fetchReasonsForHide() {
    return instance.get(`/api/interactions/reasons/`);
  },
  downloadCreatorsList(params?: DownloadCreatorsParams) {
    return instance.get(`/api/creators/creator-export/`, {
      params,
      responseType: "blob",
    });
  },
};

export default creatorsApi;
